var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.18106 6.4338L10.1434 4.44216C10.3135 4.2695 10.3732 4.01653 10.2983 3.786C10.2233 3.55566 10.0264 3.38616 9.78732 3.34628L7.02881 2.88838L5.74098 0.406573C5.62933 0.191627 5.40734 0.056427 5.16494 0.056427C4.92255 0.056427 4.70056 0.191441 4.58891 0.406573L3.3009 2.88783L0.542754 3.34647C0.303697 3.38616 0.106554 3.55566 0.0318145 3.78619C-0.0431109 4.01653 0.0166074 4.2695 0.186673 4.44216L2.14864 6.4338L1.73229 9.19862C1.69612 9.43823 1.79664 9.67803 1.99267 9.82065C2.10562 9.90262 2.23952 9.94454 2.37435 9.94454C2.47338 9.94454 2.57279 9.92191 2.66459 9.87592L5.16494 8.62518L7.66567 9.87573C7.88247 9.98422 8.14156 9.9629 8.33759 9.82028C8.53362 9.67785 8.63414 9.43805 8.59797 9.19843L8.18106 6.4338Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.54526f89cb6337e2a390e9882716935a.svg";
export { ForwardRef as ReactComponent };